/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIResponseBase,
  EventPostRequest,
} from '../models';
import {
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
    EventPostRequestFromJSON,
    EventPostRequestToJSON,
} from '../models';

export interface PostActionsSdkRequest {
    eventPostRequest: EventPostRequest;
}

export interface PostEventsRequest {
    eventPostRequest: EventPostRequest;
}

/**
 * 
 */
export class EventsApi extends runtime.BaseAPI {

    /**
     * Post information that can used to build and publish an event originating from the SlashID SDK
     * Publish an event from the SDK
     */
    async postActionsSdkRaw(requestParameters: PostActionsSdkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventPostRequest === null || requestParameters.eventPostRequest === undefined) {
            throw new runtime.RequiredError('eventPostRequest','Required parameter requestParameters.eventPostRequest was null or undefined when calling postActionsSdk.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/actions/sdk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventPostRequestToJSON(requestParameters.eventPostRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Post information that can used to build and publish an event originating from the SlashID SDK
     * Publish an event from the SDK
     */
    async postActionsSdk(requestParameters: PostActionsSdkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postActionsSdkRaw(requestParameters, initOverrides);
    }

    /**
     * Post information that can used to build and publish an event. Deprecated, use `/actions`.
     * Publish an event
     */
    async postEventsRaw(requestParameters: PostEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventPostRequest === null || requestParameters.eventPostRequest === undefined) {
            throw new runtime.RequiredError('eventPostRequest','Required parameter requestParameters.eventPostRequest was null or undefined when calling postEvents.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventPostRequestToJSON(requestParameters.eventPostRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Post information that can used to build and publish an event. Deprecated, use `/actions`.
     * Publish an event
     */
    async postEvents(requestParameters: PostEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postEventsRaw(requestParameters, initOverrides);
    }

}
